export type PerfNum = { typeCode?: string | null; number?: string | null };

export function toPerfList(list?: PerfNum[] | null, usageNumberInSearchExclude: string[] = []): string[] {
  if (!Array.isArray(list) || list.length === 0) return [];
  const seen = new Set<string>();
  const out: string[] = [];

  for (const pn of list) {
    const num = (pn?.number ?? '').trim();
    if (!num) continue;

    const type = (pn?.typeCode ?? '').trim();

    if (usageNumberInSearchExclude.includes(type.toUpperCase())) {
      continue;
    }

    const display = type ? `${type}:${num}` : num;

    const key = `${type.toLowerCase()}|${num.toLowerCase()}`;
    if (!seen.has(key)) {
      seen.add(key);
      out.push(display);
    }
  }
  return out;
}

export function toPerfString(list?: PerfNum[] | null, usageNumberInSearchExclude: string[] =[]): string {
  return toPerfList(list, usageNumberInSearchExclude).join(', ');
}   